export function clamper(min, max) {
    return (value) => Math.max(min, Math.min(value, max));
}
